const appVersionLabel = 'Version 5.0.0';

export default appVersionLabel;
